/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ptl': {
    width: 9,
    height: 9,
    viewBox: '0 0 9 9',
    data: '<path pid="0" d="M6.504 2.132L1.768 6.868a3.351 3.351 0 0 1-.004-4.74 3.357 3.357 0 0 1 4.74.004zm.46-.46a4.001 4.001 0 0 0-5.656 5.656 4.001 4.001 0 0 0 5.657-5.656z" fill-rule="evenodd"/>'
  }
})
